<template>
	<div class="c-render-copy">
		<article>{{ script.copy }}</article>
	</div>
</template>

<script>
export default {
	data: function () {
		return {};
	},

	props: {
		script: {},
	},

	computed: {
		results: function () {
			return [
				{
					name: 'va-gen-01',
					script: this.script,
				},
			];
		},
	},

	methods: {
		next: function () {
			this.$emit('next');
		},
	},
};
</script>

<style lang="scss">
.c-render-copy {
	margin-bottom: 1rem;
	padding: 0.5rem;

	article {
		white-space: break-spaces;
	}
}
</style>
